import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export type Crumb = {
  /** Visible label */
  label: string;
  /** Optional href — omit on the last (current) crumb */
  to?: string;
};

type Props = {
  /** Ordered list of crumbs *after* Home. The Home crumb is always prepended. */
  items: Crumb[];
  className?: string;
};

/**
 * Standard shadcn breadcrumb wrapper used on every non-home page.
 * Always prepends a "Home" link to "/". Pass the rest as `items`.
 *
 * Example:
 *   <PageBreadcrumb items={[{ label: "Directory", to: "/directory" }, { label: tool.name }]} />
 */
const PageBreadcrumb = ({ items, className }: Props) => {
  return (
    <div className={`container mx-auto px-4 pt-4 ${className ?? ""}`}>
      <Breadcrumb>
        <BreadcrumbList className="font-mono text-xs">
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {items.map((crumb, i) => {
            const isLast = i === items.length - 1;
            return (
              <span key={`${crumb.label}-${i}`} className="contents">
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  {isLast || !crumb.to ? (
                    <BreadcrumbPage className="text-foreground truncate max-w-[260px] sm:max-w-none">
                      {crumb.label}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={crumb.to}>{crumb.label}</Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </span>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default PageBreadcrumb;
